import { styled } from '@mui/material';

import { getShouldForwardPropFn } from '@mopla/utils';

interface IStyledDivProps {
	disabled: boolean;
}

export const StyledDiv = styled('div', {
	shouldForwardProp: getShouldForwardPropFn<IStyledDivProps>('disabled'),
})<IStyledDivProps>(({ theme, disabled }) => ({
	backgroundColor: disabled
		? theme.palette.neutral[60]
		: theme.palette.secondary.main,
	border: `1px solid ${theme.palette.neutral[0]}`,
	borderRadius: '50%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	aspectRatio: '1',
	width: '19px',

	'&>svg': {
		color: disabled ? theme.palette.neutral[80] : theme.palette.primary.main,
	},
}));
